import { z } from "zod"

// Define the schema as an object with all of the env
// variables and their types
export const envSchema = z.object({
  VITE_APP_VER: z.string(),
  VITE_GIT_HASH: z.string(),
  VITE_ENV: z.union([z.literal("staging"), z.literal("production")]).default("staging"),
  VITE_TOKEN_FACTORY_PROCESS: z.string(),
  VITE_AMM_FACTORY_PROCESS: z.string(),
  VITE_TOKEN_LOCKER_PROCESS: z.string(),
  VITE_DEXI_PROCESS: z.string(),
  VITE_AGENT_FACTORY_PROCESS: z.string(),
  VITE_HISTORY_CUTOFF: z.string(),
  VITE_MOCKAO: z.string(),
  VITE_AO: z.string(),
  VITE_HB_API: z.string(),
  VITE_DEXI_CACHE_PROCESS: z.string().optional(),
  VITE_TOKENDROP_CACHE_PROCESS: z.string().optional(),
  VITE_AMM_FACTORY_CACHE_PROCESS: z.string().optional(),
  VITE_SUPABASE_ANON_KEY: z.string(),
  VITE_SUPABASE_URL: z.string(),
  VITE_DATA_SOURCE: z
    .union([z.literal("hb"), z.literal("supabase"), z.literal("dryrun")])
    .optional()
    .default("supabase"),
  VITE_DATA_SOURCE_FALLBACK: z
    .union([z.literal("true"), z.literal("false")])
    .optional()
    .default("true")
    .transform((val) => val === "true"),
  VITE_GL_PROCESS: z.string(),
})

export default function validateEnv(env: Record<string, string>) {
  try {
    const result = envSchema.safeParse(env)

    if (!result.success) {
      // Format error messages without using zod-error
      const errorMessages = result.error.issues.map((issue, index) => {
        const path = issue.path.length > 0 ? issue.path.join(".") : "root"
        return `🔥 Error #${index + 1}: ${path} - ${issue.message} \n`
      })
      const errorMessage = errorMessages.join("")
      throw new Error(errorMessage)
    }

    console.log("🚀 Environment variables are valid!")
    console.log("🔥 VITE_ENV:", result.data.VITE_ENV)
    console.log("\nVITE_APP_VER:", JSON.stringify(result.data.VITE_APP_VER))
    console.log("VITE_GIT_HASH:", result.data.VITE_GIT_HASH)
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message)
    } else {
      console.error("An unknown error occurred")
    }
    console.info("Maybe you forgot to set the environment variables? 🤔 npm run generate-env")
    process.exit(0)
  }
}
